/**
 * Brand button. Variants: primary (green), gold, ghost, outline. Sizes: sm/md/lg.
 * Renders as <a> when `href`/`to` is given, else <button>. CSS-only hover lift.
 */
import { Link } from 'react-router-dom';
import styles from './Button.module.css';

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  to,
  href,
  className = '',
  iconLeft: IconLeft,
  iconRight: IconRight,
  ...rest
}) {
  const cls = `${styles.btn} ${styles[variant]} ${styles[size]} ${className}`.trim();
  const inner = (
    <>
      {IconLeft && <IconLeft size={18} aria-hidden="true" />}
      <span>{children}</span>
      {IconRight && <IconRight size={18} aria-hidden="true" />}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {inner}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {inner}
      </a>
    );
  }
  return (
    <button className={cls} {...rest}>
      {inner}
    </button>
  );
}

export default Button;
